
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorStaticVertical as ObiMotorStaticVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-static-vertical.js';
 
 
 

 
 export const ObiMotorStaticVertical = createComponent({
   react: React,
   tagName: 'obi-motor-static-vertical',
   elementClass: ObiMotorStaticVerticalElement,
   events: {
     
   }
  });
 
 